import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout } from '../Layout';


function AdditionalTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    

    const handleAdditionalFormLoad = useCallback(() => {
        props.additionalFormLookupsLoad();

    }, []);

    return (
        <div style={{marginTop:"10px"}}>
            <FormField
                currrentUser={currentUser}
                layoutId='517f6e9b-8320-4445-88ca-e6ea551a4c41'
                layoutName='WMItemDataEntryTestForm'
                defaultFormSchema={AdditionalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdditionalTab);
